import React from 'react';
import styled from 'styled-components';
import {
  ClientPreleadCustomizeItem,
  Prelead,
  useUpdateClientPreleadCustomizeItemNameMutation,
} from 'api';
import TextItem from './Text';
import NumberItem from './Number';
import DateItem from './Date';
import SelectItem from './Select';
import {Input as UIInput} from 'components/antd';
import HashTag from './Icon/HashTag';
import Text from './Icon/Text';
import Calendar from './Icon/Calendar';
import Tag from './Icon/Tag';

const itemComponents: {[key: string]: any} = {
  text: TextItem,
  number: NumberItem,
  date: DateItem,
  select: SelectItem,
};

const itemIcons: {[key: string]: any} = {
  text: Text,
  number: HashTag,
  date: Calendar,
  select: Tag,
};

interface Props {
  prelead: Prelead;
  clientPreleadCustomizeItem: ClientPreleadCustomizeItem;
}

export default ({prelead, clientPreleadCustomizeItem}: Props) => {
  const ItemComponent = React.useMemo(
    () => itemComponents[clientPreleadCustomizeItem.dataType],
    [clientPreleadCustomizeItem],
  );

  const ItemIcon = React.useMemo(
    () => itemIcons[clientPreleadCustomizeItem.dataType],
    [clientPreleadCustomizeItem],
  );

  const [value, setValue] = React.useState(clientPreleadCustomizeItem.name);
  const [updateName] = useUpdateClientPreleadCustomizeItemNameMutation();

  const update = (e: any) => {
    value.trim() !== '' &&
      updateName({
        variables: {
          name: value,
          id: clientPreleadCustomizeItem.id,
        },
      });
  };

  return (
    <Container>
      <ItemIcon />
      <div>
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onPressEnter={update}
          onBlur={update}
          placeholder="未入力"
        />
      </div>
      <div>
        <ItemComponent
          prelead={prelead}
          clientPreleadCustomizeItem={clientPreleadCustomizeItem}
        />
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--text-color-1);
  min-height: 24px;
  width: 100%;

  & > div:first-child {
    width: 180px;
  }
  & > div:last-child {
    flex: 1;
  }
`;

const Input = styled(UIInput)`
  border-color: transparent;
  background-color: transparent;
  border-radius: 4px;
  width: 180px;

  &:hover {
    border: 1px solid var(--text-color-3);
  }
`;
